import create from "zustand";

const store = (set) => ({
  appMode: "",
  setAppMode: (appMode) => set({ appMode }),
  aspectRatio: "1 / 1",
  setAspectRatio: (aspectRatio) => set({ aspectRatio }),
});

const useAppStore = create(store);
export default useAppStore;
